import toSingleByte from "./toSingleByte";

export default (text) => {
  let result = toSingleByte(text)
  result = result.replace(/\D/g, '')
  return result
}
